/* =====================================================
   EN CUSTOM OVERRIDES
   Theme: Enterprise
   Keep this file separate from theme JS for updates
===================================================== */

document.addEventListener('DOMContentLoaded', function () {
  const countdowns = document.querySelectorAll('[data-campaign-countdown]');

  countdowns.forEach(function (countdown) {
    const endTimestamp = Number(countdown.dataset.endTimestamp) * 1000;

    if (!endTimestamp) return;

    const daysEl = countdown.querySelector('[data-countdown-days]');
    const hoursEl = countdown.querySelector('[data-countdown-hours]');
    const minutesEl = countdown.querySelector('[data-countdown-minutes]');
    const secondsEl = countdown.querySelector('[data-countdown-seconds]');

    const pad = function (number) {
      return String(number).padStart(2, '0');
    };

    const expireCampaign = function () {
      countdown.innerHTML = '<span class="campaign-expired-label">Campaign closed</span>';

      // Hide the entire add to cart wrapper (quantity input + button)
      const addToCartWrappers = document.querySelectorAll('.product-info__add-to-cart');
      addToCartWrappers.forEach(function (wrapper) {
        wrapper.style.display = 'none';
      });

    };

    const updateCountdown = function () {
      const now = Date.now();
      const distance = endTimestamp - now;

      if (distance <= 0) {
        clearInterval(timer);
        expireCampaign();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    updateCountdown();

    const timer = setInterval(updateCountdown, 1000);
  });
});



//Sorority Dropdown for variant dropdown template 

document.querySelectorAll('.select-container-custom-dropdown [data-custom-dropdown]').forEach((dropdown) => {
  dropdown.addEventListener('change', (e) => {
    const container = e.target.closest('.select-container-custom-dropdown');
    const skuInput = container?.querySelector('[data-variant-sku]');
    if (!skuInput) return;
    const sku = e.target.selectedOptions[0]?.dataset.sku || '';
    skuInput.value = sku;
  });
});

